var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#94C3E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.198 13.396V13.084C11.198 12.724 11.242 12.42 11.33 12.172C11.426 11.916 11.546 11.7 11.69 11.524C11.834 11.34 11.986 11.184 12.146 11.056C12.314 10.92 12.47 10.792 12.614 10.672C12.758 10.552 12.874 10.424 12.962 10.288C13.058 10.144 13.106 9.976 13.106 9.784C13.106 9.52 13.01 9.324 12.818 9.196C12.634 9.068 12.378 9.004 12.05 9.004C11.634 9.004 11.322 9.112 11.114 9.328C10.914 9.536 10.818 9.852 10.826 10.276H9.22997C9.22997 9.684 9.34997 9.184 9.58997 8.776C9.82997 8.36 10.166 8.044 10.598 7.828C11.03 7.612 11.526 7.504 12.086 7.504C12.542 7.504 12.966 7.58 13.358 7.732C13.75 7.884 14.066 8.132 14.306 8.476C14.554 8.812 14.678 9.26 14.678 9.82C14.678 10.172 14.63 10.468 14.534 10.708C14.438 10.948 14.314 11.152 14.162 11.32C14.018 11.488 13.862 11.636 13.694 11.764C13.534 11.892 13.378 12.024 13.226 12.16C13.082 12.288 12.962 12.436 12.866 12.604C12.77 12.772 12.722 12.976 12.722 13.216V13.396H11.198ZM11.054 16V14.296H12.914V16H11.054Z",
    fill: "#94C3E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/Icon-Help.020440d0d045064560422885c6212650.svg";
export { ForwardRef as ReactComponent };